import { type MetaFunction } from '@remix-run/node'
import hagerty from './hagerty.png'

export const meta: MetaFunction = () => [
	{ title: 'Hagerty' },
	{
		name: 'description',
		content:
			"We offfer insurance from Hagerty, the world's largest provider of collector car insurance.",
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Hagerty</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<img src={hagerty} alt="Hagerty" className="w-64" />
				<h3>History</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Hagerty was started in 1983 to fill a gap in the collector insurance
					industry.
				</p>
				<h3>Products</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Collector Car Insurance, Collector Boat Insurance.
				</p>
				<h3>Financial Strength</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Hagerty Policies are underwritten by One Beacon Insurance Group, an
					insurance company that bears the A.M. Best rating of A (Excellent).
				</p>
				<h3>Contact Information</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Website:{' '}
					<a
						href="http://www.hagerty.com/"
						target="_blank"
						rel="noopener noreferrer"
						className="text-blue-600 underline"
					>
						http://www.hagerty.com/ (opens in a new tab)
					</a>
				</p>
				<h3>Make a Payment</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					<a
						title="Hagerty Online Payment"
						href="https://login.hagerty.com/TemporaryAccess?purpose=PayBill"
						target="_blank"
						rel="noopener noreferrer"
						className="text-blue-600 underline"
					>
						https://login.hagerty.com/TemporaryAccess?purpose=PayBill (opens in
						a new tab)
					</a>
					<br />
					<br />
					Mailing Address:
					<br />
					P.O. Box 1303
					<br />
					Traverse City, MI 49685-1303
				</p>
			</p>

			<section>
				<h3>Claims</h3>

				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					<a
						title="Hagerty Claims"
						href="https://www.hagerty.com/insurance/claims"
						target="_blank"
						rel="noopener noreferrer"
						className="text-blue-600 underline"
					>
						https://www.hagerty.com/insurance/claims (opens in a new tab)
					</a>
				</p>
			</section>

			<section>
				<h3>Home Office Address</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Hagerty
					<br />
					P.O. Box 1303
					<br />
					Traverse City, MI 49685-1303
				</p>
			</section>
		</main>
	)
}
